var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.2804,
    height: 30.2804,
    transform: "translate(0.562988 0.772461)",
    fill: "white",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2732 8.34253L8.13306 23.4827M8.13306 8.34253L23.2732 23.4827",
    stroke: "#000C2B",
    strokeOpacity: 0.81,
    strokeWidth: 2.52336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.19062fc28e98b86514507fad7c8db94f.svg";
export { ForwardRef as ReactComponent };